/**
 * MODIFICA 2026-08-19: Chiamata API per sincronizzare i dati di una prenotazione
 * da Bokun (passengerInfo) e aggiornare il DB.
 */

import { Call } from "../../../api/apiCall";

export interface SyncBookingResult {
	success: boolean;
	confirmationCode: string;
	bookingId: number;
	externalActivityId: number | null;
	externalActivityIds: number[];
}

export const syncBooking = async (confirmationCode: string): Promise<SyncBookingResult> => {
	try {
		const res = await Call("bookings/sync-booking", "post", { confirmationCode });

		if (res.ok) {
			return await res.json() as SyncBookingResult;
		}

		const errorData = await res.json();
		throw new Error(errorData.message || `Errore server: ${res.status}`);
	} catch (error) {
		throw new Error(error instanceof Error ? error.message : "Impossibile connettersi al servizio di sincronizzazione.");
	}
};
